import { DetailBox } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Container, Row } from 'reactstrap';
import GoBackToListButton from '../../../components/buttons/GoBackToListButton';
import { TranslationsKeys } from '../../../locales/translations';
import { useWarningsSummaryDetailsLoader } from '../loaders/StudentWarningsSummaryDetailsLoader';

const StudentWarningsSummaryDetailsBox = () => {
  const { t } = useTranslation(TranslationsKeys.STUDENT_ALERTS_DETAILS);
  const { result } = useWarningsSummaryDetailsLoader();

  const columns = useMemo(() => {
    if (!result?.success || !result?.data) {
      return [];
    }
    return [
      {
        title: t('box.student'),
        body: result?.data?.name || '',
      },
      {
        title: t('box.identification'),
        body: result?.data?.identification || '',
      },
      {
        title: t('box.studyPlan'),
        body: result?.data?.studyPlan,
      },
      {
        title: t('box.promo'),
        body: result?.data?.promo,
      },
      {
        title: t('box.course'),
        body: result?.data?.course,
      },
    ];
  }, [result, t]);

  if (!result?.success || !result?.data) {
    return <></>;
  }

  return (
    <Container fluid>
      <Row className="pb-4 gutters-filters">
        <Col xs={12} className="pt-3" md={6}>
          <GoBackToListButton />
        </Col>
        <Col xs={12} md={6}>
          <div>
            <DetailBox columns={columns} />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default StudentWarningsSummaryDetailsBox;
